import axios from "axios";
import { ProjectApi, RecreateApprovalFlow } from ".";
import { toast } from "react-toastify";

export const fetchProjects = (params = {}) => {
  return axios
    .get(`${ProjectApi}`, { params: { ...params } })
    .then((res) => {
      return res?.data;
    })
    .catch(() => {});
};

export const recreateApprovalFlowForProject = (params = {}) => {
  const id = toast.loading("Configuring...");

  try {
    return axios
      .get(`${RecreateApprovalFlow}`, { params: { ...params } })
      .then((res) => {
        toast.update(id, {
          render: "Configured Successfully",
          type: "success",
          isLoading: false,
        });

        return res?.data;
      })
      .catch(() => {});
  } catch (error) {
    return false;
  }
};
